var map = {
	"./automatic@2x.png": 58774,
	"./aws@2x.png": 6708,
	"./azure@2x.png": 72854,
	"./digitalocean@2x.png": 99419,
	"./forepaas@2x.png": 75792,
	"./gcp@2x.png": 95643,
	"./ibm@2x.png": 41999,
	"./nutanix@2x.png": 45968,
	"./openstack@2x.png": 51853,
	"./osc@2x.png": 17034,
	"./outscale@2x.png": 1979,
	"./ovh@2x.png": 46722,
	"./scaleway@2x.png": 82640,
	"./standard@2x.png": 64732,
	"./tanzu@2x.png": 52815
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34210;